import { KYMW4300Model } from '../kymw4300.model';
import { KYMW4300OutputModel } from '../vo/kymw4300-output.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';
import { PlessViewUtilsSub } from '../../../../commons/kymw00/pless-view-utils-sub.service';

/* 商品DNA一覧情報出力 */
@Injectable()
export class OutputPlanGoodsDnaListService extends PlessJsonResponderSub<any> {

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /** 処理に使用するModel */
  private model: KYMW4300Model;
  private successFunc: Function;

  vo: KYMW4300OutputModel;

  private getBody(): PlessRequest {
    interface Obj {
      [prop: string]: any
    }
    const paramObj: Obj = {
      OrderCodeFrom: this.vo.orderCodeFrom,
      OrderCodeTo: this.vo.orderCodeTo,
      MediumType: this.vo.mediumType,
      ItemCode: this.vo.itemCode,
      EbaseSpecCode: this.vo.ebaseSpecCode,
      JANCode: this.vo.janCode,
      MakerName: this.vo.makerName,
      DutiesFormWeeklyDiv: this.vo.dutiesFormWeekly,
      DutiesFormSpotDiv: this.vo.dutiesFormSpot,
      OrdrClientCode: this.vo.ordrClientCode,
      OrdrClientKanji: this.vo.ordrClientKanji,
      PayeeClientCode: this.vo.payeeClientCode,
      PayeeClientKanji: this.vo.payeeClientKanji,
      ClassCode: this.vo.classCode,
      MiddleClassCode: this.vo.middleClassCode,
      SmallClassCode: this.vo.smallClassCode,
      RegistDateFrom: this.vo.registDateFrom,
      RegistDateTo: this.vo.registDateTo,
      UpdateDateFrom: this.vo.updateDateFrom,
      UpdateDateTo: this.vo.updateDateTo,
      AdmitStatus: this.vo.admitStatus,
      GoodsDiv: this.vo.goodsDiv,
      BuyerCode: this.vo.buyerCode
	  };
    if (!PlessViewUtilsSub.isEmpty(this.vo.pcode)) {
      paramObj.PCode = this.vo.pcode;
    }

    return new PlessRequest({
      search: {
        Rec: {
          parameter: paramObj
        },
        GuideGoodsNameList: !PlessViewUtilsSub.isEmptyArray(this.vo.guideGoodsNameList) ? {
          combination : this.vo.guideGoodsNameList.map(guideGoodsName => {
            return {
              parameter: {
                GuideGoodsName: guideGoodsName
              }
            }
          })
        } : {},
        GuideStandardNameList: !PlessViewUtilsSub.isEmptyArray(this.vo.guideStandardNameList) ? {
          combination: this.vo.guideStandardNameList.map(guideStandardName => {
            return {
              parameter: {
                GuideStandardName: guideStandardName
              }
            }
          })
        } : {},
        DutiesFormDailyDivList: !PlessViewUtilsSub.isEmptyArray(this.vo.dutiesFormDailyList) ? {
          combination: this.vo.dutiesFormDailyList.map(dutiesFormDaily => {
            return {
              parameter: {
                DutiesFormDailyDiv: dutiesFormDaily
              }
            }
          })
        } : {},
        DNADivList: !PlessViewUtilsSub.isEmptyArray(this.vo.dnaDivList) ? {
          combination: this.vo.dnaDivList.map(dnaDiv => {
            return {
              parameter: {
                DNADiv: dnaDiv
              }
            }
          })
        } : {},
        CoopCodeList: !PlessViewUtilsSub.isEmptyArray(this.vo.coopCodeList) ? {
          combination: this.vo.coopCodeList.map(coopCode => {
            return {
              parameter: {
                CoopCode: coopCode
              }
            }
          })
        } : {},
        PCodeList: !PlessViewUtilsSub.isEmptyArray(this.vo.pcodeList) ? {
          // リスト検索
          combination: this.vo.pcodeList.map(pcode => {
            return {
              parameter: {
                PCode: pcode
              }
            }
          })
        } : {}
        }
    });
  }

  /** APIを呼ぶ */
  execute(model: KYMW4300Model, vo: KYMW4300OutputModel, successFunc: Function = null): void {
    this.model = model;
    this.vo = vo;
    this.successFunc = successFunc;
    this.send('outputPlanGoodsDNAList', this.getBody());
  }

  /** API通信成功時の処理(PlessResponderのメソッドをオーバーライド) */
  success(data: any) {
    if (this.successFunc !== null) {
      this.successFunc(data);
    }
  }
}
